import React, { Component } from 'react';
import './collapsibleBox.css';

const EXPAND_TRANSITION_MS = 320;

class CollapsibleBox extends Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
        this.scrollTimeout = null;
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.scrollOnExpand
            && !prevProps.isOpen
            && this.props.isOpen
        ) {
            this.scheduleScrollIntoView();
        }
    }

    componentWillUnmount() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    }

    scheduleScrollIntoView = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            const node = this.rootRef.current;
            if (node) {
                node.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }, EXPAND_TRANSITION_MS);
    };

    render() {
        const {
            icon,
            title,
            subtitle,
            isOpen,
            onToggle,
            children,
            className,
        } = this.props;

        return (
            <div
                ref={this.rootRef}
                className={`collapsible-box ${isOpen ? 'collapsible-box--open' : ''} ${className || ''}`}
            >
                <div
                    className="collapsible-box__header"
                    onClick={onToggle}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && onToggle()}
                >
                    <div className="collapsible-box__header-left">
                        <img
                            src={icon}
                            alt=""
                            className="collapsible-box__icon"
                        />
                        <div className="collapsible-box__title-container">
                            <h3 className="collapsible-box__title">{title}</h3>
                            {subtitle && (
                                <p className="collapsible-box__subtitle">{subtitle}</p>
                            )}
                        </div>
                    </div>
                    <div className={`collapsible-box__chevron ${isOpen ? 'collapsible-box__chevron--up' : ''}`}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="#004CC6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className={`collapsible-box__content ${isOpen ? 'collapsible-box__content--visible' : ''}`}>
                    {children}
                </div>
            </div>
        );
    }
}

CollapsibleBox.defaultProps = {
    scrollOnExpand: true,
};

export default CollapsibleBox;
